/**
 * KB-META
 * Purpose: Help modal component
 * Role: ui.component
 * EntryPoints: constructor(), if(), for()
 * Inputs: isHelpDialogVisible:unknown; private router:Router; private http:HttpClient; private domSanitizer:DomSanitizer; private messageService:MessageService; found.length > 0:unknown; const item of data:unknown
 * Outputs: 
 * Validation: 
 * Dependencies: Router, HttpClient, DomSanitizer, MessageService
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=help-modal/help-modal.component; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SafeHtml } from '@angular/platform-browser';
import { SecurityService } from '../../../shared/security/security.service';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MenuItem } from '../../../services/breadcrumb.service';
import { ENV } from '../../../config/environment';

@Component({
  selector: 'app-help-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    TabViewModule,
    ButtonModule,
    ToastModule,
    NgxExtendedPdfViewerModule
  ],
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss']
})
export class HelpModalComponent implements OnInit {
  @Input() menuData: MenuItem[] = [];
  
  isHelpDialogVisible: boolean = false;
  isGenusAI: boolean = false;
  
  // Help content data
  tab: string = '';
  navData: any;
  currentPage: any;
  breadcrumbs: any[] = [];
  
  // Tab content flags
  isTipsImage: boolean = false;
  isInspirationImage: boolean = false;
  isVideoImage: boolean = false;
  inspirationDefault: boolean = false;
  
  // Content data
  tipsBody: string = '';
  inspirationBody: string = '';
  inspirationDefaultBody: string = '';
  videoBody: string = '';
  tipsImage: string = '';
  inspirationImage: string = '';
  videoImage: string = '';
  tipsVideo: string = '';
  videoVideo: string = '';
  pdfUrl: string = '';
  
  // Selected tab index
  activeTabIndex: number = 0;
  altV1Url: string = ENV.altV1Url;;

  constructor(
    private router: Router,
    private http: HttpClient,
    private securityService: SecurityService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
  }
  
  openHelpModal(): void {
    this.generateBreadcrumbs(this.router.url);
  }
  
  hideDialog(): void {
    this.isHelpDialogVisible = false;
    this.isGenusAI = false;
  }

  clearTheValues(): void {
    // Reset all content flags and data
    this.isTipsImage = false;
    this.isInspirationImage = false;
    this.isVideoImage = false;
    this.inspirationDefault = false;
    
    this.tipsBody = '';
    this.inspirationBody = '';
    this.inspirationDefaultBody = '';
    this.videoBody = '';
    this.tipsImage = '';
    this.inspirationImage = '';
    this.videoImage = '';
    this.tipsVideo = '';
    this.videoVideo = '';
    this.pdfUrl = '';
  }

  getMessageTemplateData(page: string): Promise<any> {
    this.clearTheValues();
    let url = this.altV1Url+ 'nudge/messagetemplate/?templateType=partner&page=' + page;
    
    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        (res: any) => {
          console.log(res);
          if (res['items'].length !== 0) {
            resolve(res['items']);
          } else {
            resolve(null);
          }
        }, 
        error => {
          reject(error);
        }
      );
    });
  }

  generateBreadcrumbs(url: string): void {
    console.log('url-----------------', url);
    let event = url && url.split('?').length == 2 ? url.split('?')[0] : url;
    this.breadcrumbs = this.getPath(this.menuData, event).reverse();
    console.log(this.breadcrumbs);
    
    if (this.breadcrumbs && this.breadcrumbs.length > 0) {
      let totalLen = this.breadcrumbs.length;
      console.log(totalLen);
      this.currentPage = this.breadcrumbs[totalLen - 1];
      console.log('this is router', this.currentPage);
      
      if (this.currentPage && this.currentPage.title) {
        this.tab = this.currentPage.title;
        this.setDataToModal(this.currentPage.key, this.currentPage.title);
      } else {
        this.handleSpecialRoutes(event);
      }
    }
  }

  handleSpecialRoutes(event: string): void {
    if (event && event.match('/genus-connect/add-edit-patient')) {
      this.tab = 'Add/Edit Patient';
      this.setDataToModal('addPatient', 'Add/Edit Patient');
    }else if (event && event.match('/genus-connect/community-editor')) {
      this.tab = 'Add/Edit Community';
      this.setDataToModal('addCommunity', 'Add/Edit Community');
    } else if (event && event.match('/genus-connect/patient-content')) {
      this.tab = 'Community Content';
      this.setDataToModal('communityDetail', 'Community Content');
    } else if (event && event.match('/team/add-edit-team')) {
      this.tab = 'Add/Edit Portal User';
      this.setDataToModal('addUser', 'Add/Edit Portal User');
    } else if (event && event.match('/content/manage-genus-tile')) {
      this.tab = 'Manage genusTile';
      this.setDataToModal('genusContentWall', 'Manage genusTile');
    } else if (event && event.match('/content/tile-editor')) {
      this.tab = 'Add/Edit genusTile';
      this.setDataToModal('addEditCaretile', 'Add/Edit genusTile');
    } else if (event && event.match('/content/add-edit-contact-tile')) {
      this.tab = 'Add/Edit contact-tile';
      this.setDataToModal('addEditContact', 'Add/Edit contact-tile');
    } else if (event && event.match('/content/add-edit-question')) {
      this.tab = 'Add/Edit Question';
      this.setDataToModal('addEditQuestion', 'Add/Edit Question');
    } else if (event && event.match('/content/add-edit-pathway')) {
      this.tab = 'Add/Edit Pathway';
      this.setDataToModal('addEditTileBlock', 'Add/Edit Pathway');
    } else if (event && event.match('/setting/edit-partner') || event.match('/setting/add-partner')) {
      this.tab = 'Add/Edit Partner';
      this.setDataToModal('editPartner', 'Add/Edit Partner');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'No helps data exist for this page.',
        detail: ''
      });
    }
  }

  setDataToModal(key: string, title: string): void {
    console.log(key);
    this.getMessageTemplateData(key).then(async (resData) => {
      console.log(resData);
      let that = this;
      
      if (resData && resData['length'] >= 0) {
        this.navData = resData && resData['length'] ? resData[0] : [];
        
        this.tipsVideo = this.navData['tips']['videoURL'];
        console.log(this.navData);
        
        if (this.navData['tips']['body'] != " ") {
          this.isHelpDialogVisible = true;
          this.tipsBody = this.navData['tips']['body'];
        }
        
        if (this.navData['inspiration']['body'] != " ") {
          this.isHelpDialogVisible = true;
          this.inspirationBody = this.navData['inspiration']['body']; 
        }

        if (this.navData['tips']['imageURL'] !== " ") {
          this.isTipsImage = true;
          this.isHelpDialogVisible = true;
          this.tipsImage = this.navData['tips']['imageURL'];
        }

        if (this.navData['inspiration']['imageURL'] !== " ") {
          this.isInspirationImage = true;
          this.isHelpDialogVisible = true;
          this.inspirationImage = this.navData['inspiration']['imageURL'];
        }
        
        if (this.navData['pdfUrl']) {
          let pdfUrl = this.navData['pdfUrl'];
          this.pdfUrl = this.navData['pdfUrl'];
          console.log(this.pdfUrl);
          setTimeout(() => {
            that.isHelpDialogVisible = true;
          }, 1000);
        }
        
        if (this.navData['video']) {
          if (this.navData['video']['videoURL'] !== " ") {
            this.isHelpDialogVisible = true;
            this.videoVideo = this.navData['video']['videoURL'];
          }
          
          if (this.navData['video']['body'] !== " ") {
            this.isHelpDialogVisible = true;
            this.videoBody = this.navData['video']['body'];
          }
          
          if (this.navData['video']['imageURL'] !== " ") {
            this.isVideoImage = true;
            this.isHelpDialogVisible = true;
            this.videoImage = this.navData['video']['imageURL'];
          }
        }

        setTimeout(() => {
          if (!that.isHelpDialogVisible) {
            that.messageService.add({
              severity: 'warn',
              summary: 'No helps data exist for this page.',
              detail: ''
            });
          }
        }, 1000);
      }
    });
  }

  // Helper function to get path from menu data using a recursive approach
  getPath(data: MenuItem[], url: string, parents: MenuItem[] = []): MenuItem[] {
    if (!data || data.length === 0) {
      return [];
    }

    for (const item of data) {

      if (item.url === url) {
        return [item, ...parents];
      }
      
      // If this item has children, search them recursively
      if (item.children && item.children.length > 0) {
        const found = this.getPath(item.children, url, [item, ...parents]);
        if (found.length > 0) {
          return found;
        }
      }
    }
    
    // If we get here, no match was found
    return [];
  }
  
  // Method to safely display HTML content
  getSafeHtml(html: string): SafeHtml {
    return this.securityService.safeHtml(html);
  }
} 